import {
  sportGamesStatusOptions,
  sportPositionValidator,
  sportStatusOptions,
} from "../sports/shared";

export const marketStatusOptions = sportStatusOptions;
export const marketGamesStatusOptions = sportGamesStatusOptions;
export const marketPositionValidator = sportPositionValidator;

export const marketTypeOptions = [
  { value: 1, title: "common.types.regular" },
  { value: 2, title: "common.types.free_text" },
];

export const marketOutcomesActivityOptions = [
  { value: null, title: "market.outcomes_activity.not_set" },
  { value: 1, title: "market.outcomes_activity.display_inactive" },
  { value: 2, title: "market.outcomes_activity.hide_inactive" },
];

export const marketCompetitorTypeOptions = [
  { value: 1, title: "Team" },
  { value: 2, title: "Player" },
];

export const COLLAPSE_CONFIG_ID = "eventviewMarketCollapseSettings";
export const MARKET_OUTCOME_ORDER_CONFIG_ID = "us_view_event_row_market_outcome_order";
export const MARKET_LAYOUT_CONFIG_ID = "eventviewMarketLayout";
export const BETRADAR_BET_ASSIST_CONFIG_ID = "betradarBetAssist";
export const MARKET_INDICATOR_CONFIG_ID = "marketIndicator";
export const MARKET_FEATURE_FLAG_CONFIG_ID = "market-feature-flags";
export const MARKET_DISPLAY_OPTION_CONFIG_ID = "marketDisplayOption";

export const COLLAPSE_STATUSES = {
  EXPANDED: "expanded",
  COLLAPSED: "collapsed",
  SEMI_COLLAPSED: "semi_collapsed",
  SEMI_COLLAPSED_MOST_BALANCED: "semi_collapsed_most_balanced",
} as const;

export const marketCollapseStatusOptions = [
  { value: COLLAPSE_STATUSES.EXPANDED, title: "market_metadata.expanded" },
  { value: COLLAPSE_STATUSES.COLLAPSED, title: "market_metadata.collapsed" },
  { value: COLLAPSE_STATUSES.SEMI_COLLAPSED, title: "market_metadata.semi_collapsed" },
  {
    value: COLLAPSE_STATUSES.SEMI_COLLAPSED_MOST_BALANCED,
    title: "market_metadata.semi_collapsed_most_balanced",
  },
];

export const marketOutcomeOrderOptions = [
  { value: 1, title: "tournament_metadata.event_competitor_display_type_home_as_first" },
  { value: 2, title: "tournament_metadata.event_competitor_display_type_away_as_first" },
];

export const marketLayoutOptions = [
  { value: "correct-score", title: "market_metadata.display_options.correct_score" },
  { value: "market-vertical", title: "market_metadata.display_options.market_vertical" },
];

export const marketIndicatorOptions = [
  { value: "substitution", title: "market_metadata.display_options.substitution" },
];

export const marketFeatureFlagOptions = [
  { value: "substitution_bet", title: "market_metadata.display_options.substitution_bet" },
  { value: "x_up", title: "market_metadata.display_options.x_up" },
];

export const marketDisplayOptionOptions = [
  { value: 1, title: "market_metadata.display_options.two_columns_with_header" },
  { value: 2, title: "market_metadata.display_options.max_three_columns_two_mobile" },
  { value: 3, title: "market_metadata.display_options.max_three_columns_one_mobile" },
  { value: 4, title: "market_metadata.display_options.player_props_default" },
  { value: 5, title: "market_metadata.display_options.player_props_increment" },
  { value: 6, title: "market_metadata.display_options.single_outcome_specials" },
  { value: 7, title: "market_metadata.display_options.correct_score_double_increment" },
];

export const displayIdRowFields = [
  {
    type: "text-field" as const,
    name: "prefix",
    label: "",
    placeholder: "Prefix",
    flex: 1,
  },
  {
    type: "text-field" as const,
    name: "rangeFrom",
    label: "",
    placeholder: "From",
    inputType: "number" as const,
    flex: 1,
  },
  {
    type: "text-field" as const,
    name: "rangeTo",
    label: "",
    placeholder: "To",
    inputType: "number" as const,
    flex: 1,
  },
];
